import stickerImg from '../../assets/screenshots/sticker.png';
import { Locale } from '../../i18n/types';
import { BrandHighlight } from '../BrandHighlight';

interface Props {
  sticker: Locale['sticker'];
  integrations: Locale['integrations'];
}

export default function EcosystemTab({ sticker, integrations }: Props) {
  return (
    <div>
      <div className="mb-5">
        <h2 className="text-white fw-semibold mb-3 section-subtitle">
          {sticker.desc.split('.')[0] + '.'}
        </h2>
        <p className="section-description">
          <BrandHighlight text={sticker.desc.substring(sticker.desc.indexOf('.') + 1).trim()} />
        </p>
        <img src={stickerImg} alt="Top tube sticker" className="responsive-image-centered" />
      </div>

      <div className="section-divider">
        <h2 className="text-white fw-semibold mb-3 section-subtitle">
          Digital Ecosystem
        </h2>
        <p className="section-description">
          <BrandHighlight text={integrations.intro} />
        </p>
        <div
          className="mb-4 px-3 py-2 info-box-secondary"
        >
          <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#a17ee0', letterSpacing: '0.05em' }}>
            {integrations.comingSoon}
          </span>
          <p className="text-secondary mb-0 mt-1 text-sm-compact">
            {integrations.comingSoonDesc}
          </p>
        </div>
      </div>
    </div>
  );
}
